<template>
	<div>
		<header class="head">
			<img class="classify" @click="table = !table" src="/static/images/Normal08/more.png">
		</header>

		<div class="box_one">
			<div class="main-body">
				<ul class="nav_list nav_list_blue">
					<li class="query-tsecure" style="margin-bottom: 0;">
						<img src="/static/images/Normal08/icon_19.png">
						真伪查询
					</li>
				</ul>
			</div>
			<div class="from-box">
				<ul>
					<li>商品防伪码</li>
					<li><input class="from-input" v-model="vcode" maxlength="6" @keyup.enter="CodeVerify" type="text" /></li>
				</ul>
				<ul class="from-ul">
					<li>验证码</li>
					<li><input class="from-input code" v-model="code" maxlength="4" @keyup.enter="CodeVerify" type="tel" /></li>
					<li class="genValidCode" v-text="codeStr"></li>
				</ul>
				<div class="from-button" @click="CodeVerify">查询</div>
			</div>
		</div>

		<div class="box_two" v-if="quety_return">
			<div class="quety_return" v-text="quety_return"></div>
			<footer class="fooder_two">zcyj Inc. © 2016-2030</footer>
		</div>

		<!-- 弹窗 -->
		<div class="mask-box" v-if="table">
			<img class="close" @click="table = !table" src="/static/images/Normal08/close_01.png">
			<ul class="nav_list nav_list_white">
				<li class="query-tsecure" @click="table = !table">
					<img src="/static/images/Normal08/icon_17.png">
					真伪查询
				</li>
				<li class="query-result" @click="pageJump('/Normal08')">
					<img src="/static/images/Normal08/icon_18.png">
					查询结果
				</li>
			</ul>
		</div>

		<!-- 提示框 -->
		<section id="MaskedBlock" v-if="hintTxt">
			<i class="Masked"></i>
			<div class="ToolTip">
				<ul>
					<li>系统提示</li>
					<li class="MaskedMain" v-text="hintTxt"></li>
					<li class="confirm" v-on:click="CloseTip">确定</li>
				</ul>
			</div>
		</section>

		<!-- loading -->
		<K-ModelLoading v-if="ModelLoading"></K-ModelLoading>

	</div>
</template>

<script>
let self;
import axios from 'axios'
import ModelLoading from '@/components/ModelLoading.vue'
export default {
	name: 'Secure',
  components: {
    'K-ModelLoading': ModelLoading
  },
	data() {
		return {
			tag: null,
			vcode: null,
			code: null,
			codeStr: null,
			table: false,
			hintTxt: null,
			address: null,
			quety_return: null,
			ModelLoading: false
		}
	},
	created() {
		self = this;
		this.randomCode();
		this.tag = this.$route.params.id;
	},
	methods: {
		CloseTip() {
			this.hintTxt = null;
		},
		pageJump(url) {
			this.$router.go(-1);
		},
		randomCode() {
			let code = 0;
			while (code < 1000) {
				code = Math.floor(Math.random() * 10000);
			}
			this.codeStr = code;
		},
		CodeVerify() {
			if (!this.vcode) {
				this.hintTxt = "防伪码不能为空"
				return;
			}
			if (!this.code) {
				this.hintTxt = "验证码不能为空"
				return;
			}
			if (this.codeStr != this.code) {
				this.hintTxt = "验证码不正确"
				return;
			}

			//获取定位
			const p = new Promise((resolve,reject)=>{
				var geolocation = new BMap.Geolocation();
				geolocation.getCurrentPosition(function(r){
					if(this.getStatus() == BMAP_STATUS_SUCCESS){
						var mk = new BMap.Marker(r.point);
						var geoc = new BMap.Geocoder();
						geoc.getLocation(mk.point, function(rs){
							var addComp = rs.addressComponents;
							self.address =  addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber  //经纬度定位
							resolve();
						});
					}else {
						reject();
						self.hintTxt = this.getStatus();
					}
				},{enableHighAccuracy: true})
			})

			//获取定位成功
			const scan = p.then(() => {
				return new Promise((resolve,reject)=>{
					self.ModelLoading = true; //loading
					self.quety_return = null; //清除查询记录
					axios.get(this.GetServerUrl(1) + "queryVerify/" + this.tag + "/" + this.vcode)
					.then(function (response) {
						self.ModelLoading = false;
						var res = response.data;
						if (res.code == 200) {
							resolve(); //成功记录扫码记录
							self.quety_return = `您查询的防伪码为正牌产品，请放心使用！`;
						} else {
							self.quety_return = `您输入的防伪码系统无法比对，请确认后再重新输入，或与我们联系。`;
						}
					}).catch(function (error) {
						reject(); //失败则结束下一步处理
						self.ModelLoading = false;
						self.quety_return = `您输入的防伪码系统无法比对，请确认后再重新输入，或与我们联系。`;
						self.vcode = '';
					})
				})
			})

			//存储查询记录
			scan.then(()=>{
				console.log('记录查询结果...');
			},()=>{
				console.log('防伪码查询错误，执行结束...');
			})
		}
	},
}
</script>

<style scoped>
* {
	padding: 0;
	margin: 0;
	list-style: none;
	outline: none !important;
	font-family: "微軟正黑體", sans-serif;
}

input,
select {
	border: 0;
	outline: none;
	border-radius: 0;
	appearance: button;
	-moz-appearance: button;
	/* Firefox */
	-webkit-appearance: button;
	/* Safari 和 Chrome */
}

.hidebox {
	display: none;
}

.head {
	height: 45px;
	position: fixed;
	width: 100%;
	top: 0;
	left: 0;
	display: block;
	z-index: 2;
	background-color: #063a6b;
}

.classify {
	display: block;
	width: 26px;
	margin-top: 13px;
	margin-left: 15px;
}

.main-body {
	margin-top: 45px;
}

.banner img {
	display: block;
	width: 100%;
}

.maib-box {
	padding: 15px;
	background-color: #ced8e1;
}

.maib-box ul li {
	margin-bottom: 15px;
}

.maib-box ul li:last-child {
	margin-bottom: 0;
}

.fooder {
	padding: 20px 0;
	text-align: center;
	margin-top: 40px;
	background-color: #ced8e1;
}

.mask-box {
	z-index: 3;
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background-color: #063a6b;
}

.close {
	display: block;
	width: 22px;
	top: 13px;
	left: 15px;
	position: absolute;
	opacity: 0.6;
}

.nav_list {
	font-size: 24px;
	text-align: center;
	position: relative;
}

.nav_list_blue {
	color: #063a6b;
}

.nav_list_white {
	color: #FFF;
	margin-top: 18%;
}

.nav_list li {
	margin-bottom: 5%;
	padding-bottom: 5%;
	border-bottom: 2px solid rgba(255, 255, 255, .1);
}

.nav_list img {
	width: 30px;
	display: table;
	position: absolute;
	margin-top: 1px;
	left: calc(50% - 90px);
}

.from-box {
	padding: 15px;
	background-color: #FFF;
}

.from-input {
	width: calc(100% - 30px);
	margin-top: 5px;
	border-radius: 3px;
	height: 38px;
	padding: 0 15px;
	line-height: 38px;
	border: 1px solid #CCC;
	font-size: 17px;
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}

.from-ul {
	margin-top: 20px;
	position: relative;
}

.from-button {
	display: table;
	margin: 0 auto;
	margin-top: 30px;
	padding: 10px 0;
	width: 200px;
	font-size: 20px;
	color: #27547f;
	text-align: center;
	border-radius: 3px;
	border: 1px solid #acbecd;
	background-color: #cdd8e1;
	cursor: pointer;
}

.code {
	width: calc(100% - 130px);
}

.genValidCode {
	font-size: 22px;
	color: #0a91f6;
	font-family: arial;
	letter-spacing: 4px;
	font-weight: bold;
	text-align: center;
	line-height: 38px;
	cursor: pointer;
}

.quety_return {
	margin-top: 80px;
	padding: 15px;
	line-height: 25px;
	color: #444;
	background-color: #ced8e1;
}

.fooder_two {
	text-align: center;
	padding: 25px;
	color: #444;
	background-color: #FFF;
}

.query-tsecure {
	padding: 20px;
}

.genValidCode {
	width: 88px;
	height: 38px;
	position: absolute;
	right: 0;
	bottom: 2px;
	background: url("/static/images/Normal08/genValidCode.jpg");
	background-size: 100% 100%;
}

.confirm{
	background-color: #063a6b !important;
}

</style>



// WEBPACK FOOTER //
// src/public-view/Secure.vue